import React, { FunctionComponent } from 'react';
import { Menu } from 'semantic-ui-react';
import { NavLink } from 'react-router-dom';
import withStyles from 'react-jss';

import { ClassProp } from 'helpers/types';

import styles from 'components/Header/components/Navigation/Navigation.styles';

type Styles = ClassProp<typeof styles>;
type Props = {
  classes: Styles;
  path: string;
  label: string;
  key: string;
  disabled?: boolean;
};

const MenuItems: FunctionComponent<Props> = ({
  classes,
  path,
  label,
  key,
  disabled,
}) => {
  if (disabled) {
    return (
      <Menu.Item
        className={classes.menuItem}
        content={label}
        key={key}
        disabled
      />
    );
  }

  return (
    <Menu.Item
      activeClassName={classes.active}
      className={classes.menuItem}
      exact
      to={path}
      content={label}
      as={NavLink}
      key={key}
    />
  );
};

export default withStyles(styles)(MenuItems);
